/* eslint-disable no-nested-ternary */
/* eslint-disable */
import React, { memo, useMemo, Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';

import { formatCurrency } from '@utils';
import Button from '@components/Button';
import { API } from '@root/api';
import { Summary, Wrapper, BankDetails } from '@components/PaymentBox/style';

PaymentBox.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.object,
      expireAt: PropTypes.string,
      paidAt: PropTypes.string,
      name: PropTypes.string,
      kind: PropTypes.string,
      paymentPath: PropTypes.string,
    }),
  ).isRequired,
  finalAmount: PropTypes.shape({
    currencySymbol: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  bankAccount: PropTypes.shape({
    bankAccountNumber: PropTypes.string,
    bankName: PropTypes.string,
    bicSwift: PropTypes.string,
    name: PropTypes.string,
  }),
  postedTransactions: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.shape({
        value: PropTypes.number,
        currencySymbol: PropTypes.string,
      }),
      kind: PropTypes.string,
      transactionDate: PropTypes.string,
    }),
  ).isRequired,
};

const getPaymentPath = async (url) => {
  try {
    const {
      data: { data },
    } = await API.get(url);

    window.location.href = data.redirectUrl;
    // console.log({ data, url: data.redirectUrl });
  } catch (error) {
    // eslint-disable-next-line
    console.debug(error);
  }
};

const POSTED_TRANSACTION_KINDS = {
  payment: 'Wpłata',
  refund: 'Zwrot',
};

const POSTED_TRANSACTION_INFO = {
  payment: 'zapłacono',
  refund: 'zwrócono',
};

const PaymentRow = ({ payment, isPaid }) => {
  const paymentDetails = useMemo(() => {
    switch (payment.kind) {
      case 'cash_in_marina':
        return 'płatna w porcie';
      case 'bank_transfer':
        if (payment.expireAt) {
          return `płatna do ${payment.expireAt}`;
        }
        return 'płatna teraz';
      default:
        return 'płatna teraz';
    }
  }, [payment.kind]);

  const payNow = useCallback(() => {
    if (payment.paymentPath) {
      getPaymentPath(payment.paymentPath);
    }
  }, [payment.paymentPath]);

  return (
    <Summary>
      <div>
        {payment.name}
        <p className="info-text">{paymentDetails}</p>
      </div>
      {payment.paymentPath && !isPaid ? <Button onClick={payNow}>Kliknij i zapłać</Button> : null}
      <span>{formatCurrency(payment.amount.value, payment.amount.currencySymbol)}</span>
    </Summary>
  );
};

function PaymentBox({ finalAmount, payments, bankAccount, postedTransactions }) {
  const [search] = useSearchParams();
  const isPaid = search.get('paid') === 'true';

  const finalValue = useMemo(
    () => formatCurrency(finalAmount.value, finalAmount.currencySymbol),
    [finalAmount],
  );

  const hasPaymentPath = useMemo(
    () => payments.some((payment) => payment?.paymentPath),
    [payments],
  );

  return (
    <Wrapper>
      <style>
        {`@media screen and (max-width: 500px) {
            .payment { border-top: solid 1px #ddd; border-left: none !important; }
            header .printer {display:none}
            .paymentDate {display: flex; flex-direction: row !important; justify-content: center; gap: 5px; margin-top: 10px !important;}
          }
          @media print {
            .payments {
              border: 1px solid #ddd;
              border-radius: 16px;
            }
            .paymentDate {
              display: flex;
              flex-direction: row !important;
              justify-content: center;
              gap: 5px;
              margin-top: 10px !important;
            }
          }`}
      </style>
      <Summary>
        <span className="text--xl">Wartość rezerwacji:</span>
        <b className="text--xl">{finalValue}</b>
      </Summary>

      {postedTransactions.map((transaction, index) => (
        <Summary className="payment" key={`paymentbox-posted-${index}`}>
          <div>
            {POSTED_TRANSACTION_KINDS[transaction.kind]}:
            <p className="info-text">
              {POSTED_TRANSACTION_INFO[transaction.kind]} {transaction.transactionDate}
            </p>
          </div>
          <span className={`payment-value payment-value--${transaction.kind}`}>
            {transaction.kind === 'refund' ? '-' : ''}
            {formatCurrency(transaction.amount.value, transaction.amount.currencySymbol)}
          </span>
        </Summary>
      ))}

      {payments.map((payment, index) => (
        <PaymentRow key={`paymentbox-${index}`} payment={payment} isPaid={isPaid} />
      ))}

      {bankAccount && !isPaid && (
        <BankDetails>
          {hasPaymentPath
            ? 'W razie problemów z płatnością online, prosimy o przelew na konto:'
            : 'Prosimy o dokonanie wpłaty na konto:'}
          {bankAccount?.bankName && <strong>Bank: {bankAccount.bankName}</strong>}
          {bankAccount?.bankAccountNumber && <b>{bankAccount.bankAccountNumber}</b>}
          {bankAccount?.bicSwift && <strong>BIC/SWIFT: {bankAccount.bicSwift}</strong>}
          {bankAccount?.name && <strong>Odbiorca: {bankAccount.name}</strong>}
          <div className="paymentDate">
            <div className="paymentLabel">(w tytule przelewu proszę podać nr rezerwacji)</div>
          </div>
        </BankDetails>
      )}
    </Wrapper>
  );
}

PaymentBox.defaultProps = {
  bankAccount: null,
};

export default memo(PaymentBox);
